import { createBrowserRouter } from 'react-router'

import Layout from './components/Layout/Layout'
import Bridge from './pages/Bridge'
import SetupBridge from './pages/Bridge/SetupBridge/setup-bridge'
import StakeBridge from './pages/Bridge/StakeBridge/stake-bridge'
import StoremanDetail from './pages/Bridge/storeman-detail'
import Index from './pages/Index'
import Notfound from './pages/Notfound'
import Pos from './pages/Pos'
import PosDetail from './pages/Pos/pos-detail'
import SetupPos from './pages/Pos/SetupPos/setup-pos'
import StakePos from './pages/Pos/StakePos/stake-pos'
import StakexWan from './pages/StakexWan'
import SwapxWan from './pages/SwapxWan'

// 路由配置常量
const ROUTES = {
  HOME: '/',
  POS: '/pos',
  POS_DETAIL: '/posdetail/:id',
  BRIDGE: '/bridge',
  STOREMAN_DETAIL: '/storemandetail/:id',
  VALIDATOR_POS: '/validator/pos',
  VALIDATOR_BRIDGE: '/validator/bridge',
  SETUP_POS: '/setup/pos',
  SETUP_BRIDGE: '/setup/bridge',
  STAKEXWAN: '/stake2earn',
  SWAPXWAN: '/getxwan',
  NOT_FOUND: '*',
} as const

// 错误页面组件
const ErrorFallback = ({ message }: { message: string }) => (
  <div className="p-4 text-center text-red-500">{message}</div>
)

// 包装组件到Layout的辅助函数
const withLayout = (Component: React.ComponentType) => (
  <Layout>
    <Component />
  </Layout>
)

// 路由配置
const routes = [
  {
    path: ROUTES.HOME,
    element: withLayout(Index),
    errorElement: <ErrorFallback message="页面加载失败" />,
  },
  {
    path: ROUTES.POS,
    element: withLayout(Pos),
    errorElement: <ErrorFallback message="POS页面加载失败" />,
  },
  {
    path: ROUTES.POS_DETAIL,
    element: withLayout(PosDetail),
    errorElement: <ErrorFallback message="POS详情页面加载失败" />,
  },
  {
    path: ROUTES.BRIDGE,
    element: withLayout(Bridge),
    errorElement: <ErrorFallback message="Bridge页面加载失败" />,
  },
  {
    path: ROUTES.STOREMAN_DETAIL,
    element: withLayout(StoremanDetail),
    errorElement: <ErrorFallback message="Storeman详情页面加载失败" />,
  },
  {
    path: ROUTES.VALIDATOR_POS,
    element: withLayout(StakePos),
    errorElement: <ErrorFallback message="POS验证器页面加载失败" />,
  },
  {
    path: ROUTES.VALIDATOR_BRIDGE,
    element: withLayout(StakeBridge),
    errorElement: <ErrorFallback message="Bridge验证器页面加载失败" />,
  },
  {
    path: ROUTES.SETUP_POS,
    element: withLayout(SetupPos),
    errorElement: <ErrorFallback message="POS设置页面加载失败" />,
  },
  {
    path: ROUTES.SETUP_BRIDGE,
    element: withLayout(SetupBridge),
    errorElement: <ErrorFallback message="Bridge设置页面加载失败" />,
  },
  {
    path: ROUTES.STAKEXWAN,
    element: withLayout(StakexWan),
    errorElement: <ErrorFallback message="StakeToEarn详情页面加载失败" />,
  },
  {
    path: ROUTES.SWAPXWAN,
    element: withLayout(SwapxWan),
    errorElement: <ErrorFallback message="SwapxWan详情页面加载失败" />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: withLayout(Notfound),
  },
]

const router = createBrowserRouter(routes, {
  basename: '/',
})

export default router
export { ROUTES }
